export default __webpack_public_path__ + "static/media/Figure-6.34c97f3b.jpg";